// extracted by mini-css-extract-plugin
export default {"pagination_container":"Paginator_pagination_container__qgQOm","pagination_item":"Paginator_pagination_item__8UobB","pagination_item_active":"Paginator_pagination_item_active__ox8CP"};